// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__ofz9z","header":"ReportDetails_header__11Z5e","title":"ReportDetails_title__2gDOJ","left":"ReportDetails_left__3pKGd"};